(function () {
  if (window.__saScrollTriggerInit) return;
  window.__saScrollTriggerInit = true;

  const SCROLL_ANIMATION_TRIGGER_CLASSNAME = "scroll-trigger";
  const SCROLL_ANIMATION_OFFSCREEN_CLASSNAME = "scroll-trigger--offscreen";
  const SCROLL_ANIMATION_CANCEL_CLASSNAME = "scroll-trigger--cancel";

  function onSaScrollIntersection(elements, observer) {
    elements.forEach((element, index) => {
      if (element.isIntersecting) {
        const elementTarget = element.target;
        if (elementTarget.classList.contains(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME)) {
          elementTarget.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
          if (elementTarget.hasAttribute("data-cascade")) {
            elementTarget.style.setProperty("--animation-order", String(index));
          }
        }
        observer.unobserve(elementTarget);
      } else {
        element.target.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
        element.target.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
      }
    });
  }

  function initializeScrollAnimationTrigger(rootEl, isDesignModeEvent) {
    const root = rootEl || document;
    const animationTriggerElements = Array.from(
      root.getElementsByClassName(SCROLL_ANIMATION_TRIGGER_CLASSNAME),
    );
    if (animationTriggerElements.length === 0) return;

    if (isDesignModeEvent) {
      animationTriggerElements.forEach((element) => {
        element.classList.add("scroll-trigger--design-mode");
      });
      return;
    }

    const observer = new IntersectionObserver(onSaScrollIntersection, {
      rootMargin: "0px 0px -50px 0px",
    });
    animationTriggerElements.forEach((element) => observer.observe(element));
  }

  function replayScrollAnimation(rootEl) {
    if (!rootEl) return;
    const elements = Array.from(rootEl.querySelectorAll("." + SCROLL_ANIMATION_TRIGGER_CLASSNAME));
    if (rootEl.classList.contains(SCROLL_ANIMATION_TRIGGER_CLASSNAME)) {
      elements.unshift(rootEl);
    }
    if (elements.length === 0) return;

    elements.forEach((el) => {
      el.classList.add(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
      el.classList.remove(SCROLL_ANIMATION_CANCEL_CLASSNAME);
    });
    void rootEl.offsetWidth;
    elements.forEach((el) => {
      el.classList.remove(SCROLL_ANIMATION_OFFSCREEN_CLASSNAME);
    });
  }

  window.initializeScrollAnimationTrigger = initializeScrollAnimationTrigger;
  window.replayScrollAnimation = replayScrollAnimation;

  if (document.readyState === "loading") {
    window.addEventListener("DOMContentLoaded", () => initializeScrollAnimationTrigger());
  } else {
    initializeScrollAnimationTrigger();
  }

  document.addEventListener("shopify:section:load", (event) => {
    initializeScrollAnimationTrigger(event.target, Boolean(window.Shopify && Shopify.designMode));
  });
  document.addEventListener("shopify:section:reorder", () => {
    initializeScrollAnimationTrigger(document, Boolean(window.Shopify && Shopify.designMode));
  });
})();
